import axios from "axios";

// Influencer attribution: remember /with/<slug> for 30 days and tag API calls with it.
const KEY = "reclaim_via";
const DAYS = 30;

export const setVia = (slug) => localStorage.setItem(KEY, JSON.stringify({ slug, at: Date.now() }));
export const getVia = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "null");
    return v && Date.now() - v.at < DAYS * 864e5 ? v.slug : null;
  } catch { return null; }
};
export const visitorId = () => {
  let id = localStorage.getItem("reclaim_visitor_id");
  if (!id) { id = crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`; localStorage.setItem("reclaim_visitor_id", id); }
  return id;
};

axios.interceptors.request.use((cfg) => {
  const v = getVia();
  if (v && String(cfg.url || "").startsWith(process.env.REACT_APP_BACKEND_URL)) cfg.headers["X-Reclaim-Via"] = v;
  const g = sessionStorage.getItem("soulumo_gift_slug");
  if (g && String(cfg.url || "").startsWith(process.env.REACT_APP_BACKEND_URL)) cfg.headers["X-Soulumo-Gift"] = g;
  return cfg;
});
